<form [formGroup]="reviewForm" (ngSubmit)="submitReview()">
  @if (type() === reviewTypes.COMPLETE) {
    <div
      class="flex flex-col items-center justify-center bg-gray-100 w-full max-w-[700px] rounded-sm shadow-md"
    >
      <div class="bg-white rounded-lg shadow-lg text-center">
        <img
          [src]="data()?.images?.reviewBanner"
          alt="Rating Image"
          class="mx-auto mb-4"
        />
        <div class="">
          <img [src]="data()?.images?.tick_green" alt="" />
        </div>
        <div class="p-[20px] mb-[15px]">
          <p class="text-[#3BB000] text-[16px] font-semibold leading-[23px]">
            {{ data()?.reviewText?.reviewComplete }}
          </p>
        </div>

        <div class="flex justify-center pb-[25px]">
          <div class="flex gap-[20px] flex-wrap md:flex-nowrap justify-center">
            <button
              (click)="performRedirection('home')"
              class="bg-[#fff] text-[#5B5B5B] font-semibold border-solid border-[1px] border-[#5B5B5B] rounded-full pl-[70px] pr-[70px] pt-[14px] pb-[14px] text-center"
            >
              {{ data()?.reviewText?.reviewer?.actionButtons?.goToHome }}
            </button>
            <button
              (click)="performRedirection('products')"
              class="bg-[#F94D00] text-[#ffffff] font-semibold border-solid border-[1px] border-[#ffffff] rounded-full pl-[70px] pr-[70px] pt-[14px] pb-[14px] text-center"
            >
              {{
                data()?.reviewText?.reviewer?.actionButtons?.rateOtherProducts
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="bg-white rounded-lg shadow-md w-full">
      <div
        class="flex-wrap gap-4 p-[20px] items-center w-full bg-[#162F4D] rounded-t-lg md:flex md:flex-nowrap"
      >
        <img
          [src]="data()?.renderableComponents?.product?.imageUrl"
          class="w-32 h-32 object-cover rounded-lg"
        />

        <div>
          <h2 class="text-[18px] font-semibold mb-[7px] text-[#F8A300]">
            {{ data()?.renderableComponents?.product?.title }}
          </h2>
          <p
            class="text-[15px] text-[#ffffff] leading-[18px] md:leading-[22px]"
          >
            {{ data()?.reviewText?.reviewer?.title }}
          </p>
        </div>
      </div>

      <input hidden formControlName="reviewType" value="overall" />
      <div class="flex flex-col items-center">
        <label
          class="block text-[#000] text-[14px] font-semibold mt-[20px] mb-[10px]"
          >{{ data()?.reviewText?.reviewer?.incomplete?.ratingTitle }}</label
        >
        <rating-input (onRatingChange)="onRatingChange($event)" />
      </div>

      <div class="w-full p-[40px]">
        <div class="w-full mb-[30px]">
          <label class="block text-[#5B5B5B] text-[14px] font-medium mb-[5px]">
            {{ data()?.reviewText?.reviewer?.incomplete?.fileUploaderTitle }}
          </label>

          <media-uploader
            [data]="data()"
            (onUpload)="onUpload($event)"
            (onDelete)="onDelete($event)"
            [multiple]="true"
            [constants]="data()?.constants"
          />
        </div>

        <div class="w-full mb-[30px]">
          <label
            class="block text-[#5B5B5B] text-[14px] font-medium mb-[5px]"
            >{{ data()?.reviewText?.reviewer?.incomplete?.titleTitle }}</label
          >
          <input
            type="text"
            formControlName="reviewTitle"
            class="mt-2 p-2 w-full border rounded-lg"
          />
        </div>

        <div class="w-full mb-[30px]">
          <label
            class="block text-[#5B5B5B] text-[14px] font-medium mb-[5px]"
            >{{
              data()?.reviewText?.reviewer?.incomplete?.descriptionTitle
            }}</label
          >
          <textarea
            class="mt-2 p-2 w-full border rounded-lg h-[100px]"
            formControlName="reviewContent"
          ></textarea>
        </div>
      </div>

      <input hidden formControlName="reviewType" value="meta" />
      <div class="flex justify-center text-center w-full p-[20px]">
        <div>
          <h3 class="text-[20px] font-semibold text-black mb-[25px]">
            {{ data()?.reviewText?.reviewer?.partiallyCompleted?.title }}
          </h3>
          <div class="space-y-4">
            <div class="pb-[30px]">
              <p class="text-[#000000] text-[14px] font-semibold">
                {{
                  data()?.reviewText?.reviewer?.partiallyCompleted?.meta
                    ?.value_for_money
                }}
              </p>
              <div class="flex justify-center">
                <rating-input
                  (onRatingChange)="onRatingChange($event, 'value_for_money')"
                />
              </div>
            </div>
            <div class="pb-[30px]">
              <p class="text-[#000000] text-[14px] font-semibold">
                {{
                  data()?.reviewText?.reviewer?.partiallyCompleted?.meta
                    ?.durability
                }}
              </p>
              <div class="flex justify-center">
                <rating-input
                  (onRatingChange)="onRatingChange($event, 'durability')"
                />
              </div>
            </div>

            <div class="pb-[30px]">
              <p class="text-[#000000] text-[14px] font-semibold">
                {{
                  data()?.reviewText?.reviewer?.partiallyCompleted?.meta
                    ?.ease_of_use
                }}
              </p>
              <div class="flex justify-center">
                <rating-input
                  (onRatingChange)="onRatingChange($event, 'ease_of_use')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center pb-[25px]">
        <div class="flex gap-[20px] flex-wrap md:flex-nowrap">
          <button
            [disabled]="reviewForm.invalid"
            type="submit"
            class="bg-[#F94D00] disabled:bg-[#ccc] text-[#ffffff] font-semibold border-solid border-[1px] border-[#ffffff] rounded-full pl-[70px] pr-[70px] pt-[14px] pb-[14px] text-center"
          >
            {{
              data()?.reviewText?.reviewer?.partiallyCompleted
                ?.primaryActionTitle
            }}
          </button>
        </div>
      </div>
    </div>
  }
</form>
